import getLocal from '@/app/utils/getLocal';
import EfScrollAni from '@/efscrollani';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import ProductNav from '../../common/ProductNav';
import { generalKey } from '../../config/pageConfig';
import { useProductStore } from '../../ProductProvider';
import './css/index.scss';
import EU_Product from './EU_Product';
import EU_Product_V2 from './EU_Product_V2';
import JP_Product from './JP_Product';
import JP_Product_V2 from './JP_Product_V2';
import NA from './NA';
import NA_Product from './NA_Product';

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = getLocal();
    const { pageStatus } = useProductStore();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey[0] });

    const IS_NA_SITE = ['ca', 'us'].includes(locale);
    const IS_JP_SITE = locale === 'jp';
    const IS_NL_SITE = locale === 'nl';
    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className="page-product">
            <ProductNav activeTab={'Product'} buyLink={productMsg.buyLink} />
            {/* {IS_NA_SITE && <NA_Product />} */}
            {IS_NA_SITE && !['statusA'].includes(pageStatus) && <NA />}
            {IS_NA_SITE && ['statusA'].includes(pageStatus) && <NA_Product />}
            {IS_EU_SITE && <EU_Product_V2 />}
            {IS_NL_SITE && <EU_Product />}

            {IS_JP_SITE && ['statusA', 'statusB'].includes(pageStatus) && <JP_Product />}
            {IS_JP_SITE && !['statusA', 'statusB'].includes(pageStatus) && <JP_Product_V2 />}
        </div>
    );
}
